import { useState } from "react";
import { CONTENT } from "@/content";
import { Counter, FormPage, Honeypot, SuccessState, useFormSubmit } from "@/components/forms/FormKit";

const C = CONTENT.contact;
const EMPTY = { name: "", email: "", requesttype: C.types[0], details: "" };
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Contact() {
  const { ready, status, send, reset } = useFormSubmit("contact");
  const [f, setF] = useState(EMPTY);
  const [hp, setHp] = useState("");
  const [invalid, setInvalid] = useState({});
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const bad = { name: !f.name.trim(), email: !EMAIL.test(f.email.trim()), requesttype: !f.requesttype, details: f.details.trim().length < 5 };
    setInvalid(bad);
    if (Object.values(bad).some(Boolean)) return;
    send({ name: f.name.trim(), email: f.email.trim(), requesttype: f.requesttype, details: f.details.trim() }, hp);
  };
  const cls = (k) => `nb-input form-input ${invalid[k] ? "is-invalid" : ""}`;
  const anyInvalid = Object.values(invalid).some(Boolean);

  let body;
  if (!ready) body = <p className="panel-line" data-testid="contact-not-ready">{C.notReady}</p>;
  else if (status === "success") body = <SuccessState heading={C.successHeading} message={C.successMessage} again={C.again} library={C.library} onAgain={() => { setF(EMPTY); reset(); }} />;
  else body = (
    <form onSubmit={submit} noValidate className="form-stack" data-testid="contact-form">
      <label className="field">
        <span className="field-label">{C.nameLabel}<span className="req-dot" aria-hidden="true" /></span>
        <input className={cls("name")} maxLength={80} value={f.name} onChange={set("name")} placeholder={C.namePlaceholder} data-testid="contact-name-input" />
      </label>
      <label className="field">
        <span className="field-label">{C.emailLabel}<span className="req-dot" aria-hidden="true" /></span>
        <input type="email" className={cls("email")} maxLength={120} value={f.email} onChange={set("email")} placeholder={C.emailPlaceholder} data-testid="contact-email-input" />
        <span className="field-helper">{C.emailHelper}</span>
      </label>
      <label className="field">
        <span className="field-label">{C.typeLabel}<span className="req-dot" aria-hidden="true" /></span>
        <select className={cls("requesttype")} value={f.requesttype} onChange={set("requesttype")} data-testid="contact-type-select">
          {C.types.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      </label>
      <label className="field">
        <span className="field-label">{C.detailsLabel}<span className="req-dot" aria-hidden="true" /></span>
        <div className="counter-wrap">
          <textarea className={cls("details")} rows={7} maxLength={1500} value={f.details} onChange={set("details")} placeholder={C.detailsPlaceholder} data-testid="contact-details-input" />
          <Counter value={f.details} />
        </div>
      </label>
      {anyInvalid && <span className="form-error-text" data-testid="contact-validation-error">{C.validation}</span>}
      <Honeypot value={hp} onChange={setHp} />
      {status === "error" && <p className="form-error-box" data-testid="contact-error">{C.error}</p>}
      <button type="submit" className="nb-btn form-submit" disabled={status === "sending"} data-testid="contact-submit-button">{status === "sending" ? C.sending : C.submit}</button>
    </form>
  );

  return (
    <FormPage t={C} testId="contact-page">
      <section className="nb-card form-card">{body}</section>
    </FormPage>
  );
}
